// extracted by mini-css-extract-plugin
export default {"background":"styles_background__fNdO3","container":"styles_container__DAMg5","wrapper":"styles_wrapper__bKfmz","back":"styles_back__1f85u"};